import PhotosContainer from './containers/PhotosContainer';

export default PhotosContainer;
